import * as Sentry from '@sentry/vue';
import appVersion from '@baseDir/appVersion.json';

export default ({ app, router }) => {
    if (process.env.PROD) {
        console.log('Initialize Sentry with DSN: ', process.env.SENTRY_DSN);
        // set up Sentry
        Sentry.init({
            app,
            ignoreErrors: [
                // Ignore ChunkLoadError for CSS files as this happens when a new version is deployed
                // and the browser loads the wrong CSS file.
                'ChunkLoadError',
                'Loading CSS chunk'
            ],
            dsn: process.env.SENTRY_DSN,
            release: appVersion.version,
            integrations: [
                Sentry.browserTracingIntegration({
                    // pass router in, if applicable
                    router
                }),
                // Refer to https://docs.sentry.io/platforms/javascript/guides/vue/session-replay/#set-up for more info about session replay
                Sentry.replayIntegration({
                    maskAllText: false,
                    blockAllMedia: true
                })
            ],
            // This sets the sample rate to be 10%. You may want this to be 100% while
            // in development and sample at a lower rate in production
            replaysSessionSampleRate: 0.1,
            // If the entire session is not sampled, use the below sample rate to sample
            // sessions when an error occurs.
            replaysOnErrorSampleRate: 1.0,
            tracesSampleRate: 0.1,

            // Track Vue components - https://docs.sentry.io/platforms/javascript/guides/vue/features/component-tracking/
            trackComponents: true
        });
    }

    // Set Sentry instance on app
    app.sentry = Sentry;
};

export { Sentry };
